import * as S from './Player.styled'

export const Player = ({ url, ...props }) => (
  <S.Player url={url} playsinline={true} controls={true} {...props} />
)

export default Player
